// This import loads the firebase namespace along with all its type information.
import CoherentScreenMediaReference from './coherent-screen-media-reference-model'

export async function load_coherentScreenMediaReferences(): Promise<
  CoherentScreenMediaReference[]
> {
  throw 'Not implemented'
}

export async function delete_coherentScreenMediaReference(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_coherentScreenMediaReference(): Promise<CoherentScreenMediaReference> {
  throw 'Not implemented'
}
